import { useRef } from 'react';

export const usePendingNoteActions = () => {
    const pendingNoteActionsRef = useRef<Record<string, ((noteId: string) => void)[]>>({});

    // Queue a callback to be called when a note with tempId is saved.
    const addPendingNoteAction = (tempId: string, cb: (noteId: string) => void) => {
        const current = pendingNoteActionsRef.current;
        if (current[tempId]) {
            current[tempId].push(cb);
        } else {
            current[tempId] = [cb];
        }
    };

    // Call all queued callbacks when we get id from response and remove them from the queue.
    const triggerPendingNoteActions = (tempId: string, noteId: string) => {
        const actions = pendingNoteActionsRef.current[tempId];
        if (actions) {
            actions.forEach((cb) => cb(noteId));
            delete pendingNoteActionsRef.current[tempId];
        }
    };

    return { addPendingNoteAction, triggerPendingNoteActions };
};
